<div class="colorLogo">
    <!-- <a [routerLink]="dashBoard" name="colorLogo">
      <img src="{{ IMAGES.CF_LOGO }}" class="logo" />
    </a> -->
    <a (click)="goTohome()" name="colorLogo">
      <img src="{{ IMAGES.CF_LOGO }}" class="logo" />
    </a>
  </div>
  